import DeviceManagement from './deviceManagement' //车辆管理
import FirmwareUpdate from './firmwareUpdate' //固件升级

//车辆
export default [
    {
        path: 'equipment',
        name: 'equipment',
        meta: {
            title: '车辆',
            icon: 'equipment'
        },
        hidden: false,
        component: () => import("@/views/equipment/index.vue"),
        children:[
            ...DeviceManagement,
            ...FirmwareUpdate
        ]
    }

]